<template>
  <div class="section">
    <div class="container-products">
      <div v-for="(i, index) in Productos" :key="index">
        <Card style="width: 15rem;">
          <img
            @click="searchProduct('1')"
            slot="image"
            class="card-img-top"
            :src="i.img"
            alt="Card image cap"
          />
          <div>
            <h3 @click="searchProduct('1')" class="card-title">{{i.nombre}}</h3>
            <p class="h5">${{i.precio}}</p>
            <n-button type="primary" @click="agregar(i)"
              >Agregar al Carrito</n-button
            >
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Button } from "@/components";
export default {
  data() {
    return {
      imgSrc: "img/header.jpg",
      //  precio:this.$store.state.Precio
    };
  },
  methods: {
    searchProduct(idproducto) {
      this.$router.push({
        name: "ProductView",
        params: { idproducto: idproducto.toString() },
      });
    },
    agregar(i) {
        this.$notify({
          title: 'Producto agregado',
          message: 'Se ha agrecado el producto al carrito de compras',
          type: 'success'
        });
      this.$store.commit("increment", i);
    },
  },
  computed: {
    Productos() {
      return this.$store.state.Productos;
    },
  },
  components: {
    Card,
    [Button.name]: Button,
  },
};
</script>
<style>
.container-products {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}
.card-title {
  transition: 0.5s;
}
.card-title:hover {
  color: #828282;
}
</style>
